module.exports = __webpack_public_path__ + "static/media/exukonline-procure.70d6ebf7.png";